export const GOOGLE_API_MAPS_KEY = process.env.GOOGLE_API_MAPS_KEY;

const Config = {
  BASE_URL_API: process.env.REACT_APP_BASE_URL_API,
  BASE_URL_API_V2: process.env.REACT_APP_BASE_URL_API_V2!,
  BASE_URL_API_BUSINESS: process.env.REACT_APP_BASE_URL_API_BUSINESS,
  BASE_URL_API_CHAT: process.env.REACT_APP_BASE_URL_API_CHAT,
  BASE_URL_API_FARE: process.env.REACT_APP_BASE_URL_API_FARE,

  BASE_URL_API_PUBLIC: process.env.REACT_APP_BASE_URL_API_PUBLIC,
  BASE_URL_API_PUBLIC_V2: process.env.REACT_APP_BASE_URL_API_PUBLIC_V2,
  BASE_URL_API_PUBLIC_V3: process.env.REACT_APP_BASE_URL_API_PUBLIC_V3,

  BASE_URL_API_USER: process.env.REACT_APP_BASE_URL_API_USER,
  HEADER_AUTHORIZATION: "8@CcNWN_c`r'?=N=t4vJ@st#[`~8SV{m",
  GOOGLE_API_MAPS_KEY: "AIzaSyC8DTZMss3oYn-nEBDIBmUshcusQ0NCttY",
};

export default Config;
